import { frontRowItems, rankingList, hotTags } from '@/mocks/home'
import SectionHeading from './SectionHeading'

const trendIcon: Record<string, string> = {
  up: 'ri-arrow-up-line text-primary-500',
  down: 'ri-arrow-down-line text-accent-600',
  flat: 'ri-subtract-line text-foreground-400',
}

export default function FrontRowSection() {
  return (
    <section id="front-row" className="border-b border-background-200/80 bg-background-100/60">
      <div className="mx-auto w-full max-w-[1240px] px-4 py-12 md:px-6 md:py-16">
        <SectionHeading
          eyebrow="Front Row"
          title="今日前排热瓜"
          desc="板凳已经摆好，正在被围观的话题按热度排在这里，标题先看，摘要再决定要不要蹲。"
          actionLabel="查看全部热瓜"
          actionHref="#collections"
        />

        <div className="grid grid-cols-1 gap-10 lg:grid-cols-[1fr_320px] lg:gap-12">
          <div className="divide-y divide-background-200/80 border-t border-background-200/80">
            {frontRowItems.map((item) => (
              <article
                key={item.id}
                className="group flex flex-col gap-2 py-5 transition-colors first:pt-5 hover:bg-background-50/70 md:px-3"
              >
                <div className="flex flex-wrap items-center gap-2">
                  <span className="rounded-md bg-secondary-100 px-2 py-0.5 font-label text-[11px] font-medium text-secondary-800">
                    {item.tag}
                  </span>
                  <span className="text-xs text-foreground-500">{item.time}</span>
                </div>
                <h3 className="font-heading text-base font-semibold leading-snug text-foreground-950 transition-colors group-hover:text-primary-700 md:text-[17px]">
                  <a href="#follow-up" className="cursor-pointer">
                    {item.title}
                  </a>
                </h3>
                <p className="text-sm leading-relaxed text-foreground-600">{item.summary}</p>
                <div className="mt-1 flex items-center gap-4 text-xs text-foreground-500">
                  <span className="inline-flex items-center gap-1">
                    <i className="ri-fire-line text-sm text-primary-500"></i>
                    {item.heat}
                  </span>
                  <span className="inline-flex items-center gap-1">
                    <i className="ri-chat-3-line text-sm"></i>
                    {item.comments} 条讨论
                  </span>
                </div>
              </article>
            ))}
          </div>

          <aside className="flex flex-col gap-6 lg:sticky lg:top-24 lg:self-start">
            <div className="rounded-lg border border-background-200/80 bg-background-50 p-5">
              <div className="mb-4 flex items-center justify-between">
                <h3 className="font-heading text-base font-bold text-foreground-950">热瓜榜</h3>
                <span className="font-label text-[11px] uppercase tracking-wider text-foreground-500">实时</span>
              </div>
              <ol className="space-y-4">
                {rankingList.map((row) => (
                  <li key={row.rank} className="flex items-start gap-3">
                    <span
                      className={`mt-0.5 flex h-6 w-6 shrink-0 items-center justify-center rounded-md font-heading text-xs font-bold ${
                        row.rank <= 3
                          ? 'bg-primary-500 text-background-50'
                          : 'bg-background-200 text-foreground-700'
                      }`}
                    >
                      {row.rank}
                    </span>
                    <div className="min-w-0 flex-1">
                      <p className="truncate text-sm text-foreground-800">
                        <a href="#follow-up" className="cursor-pointer hover:text-primary-700">
                          {row.title}
                        </a>
                      </p>
                      <p className="mt-1 flex items-center gap-1 text-xs text-foreground-500">
                        <i className={`${trendIcon[row.trend]} text-sm`}></i>
                        热度 {row.heat.toLocaleString()}
                      </p>
                    </div>
                  </li>
                ))}
              </ol>
            </div>

            <div className="rounded-lg border border-background-200/80 bg-background-50 p-5">
              <h3 className="mb-4 font-heading text-base font-bold text-foreground-950">正在蹲的标签</h3>
              <div className="flex flex-wrap gap-2">
                {hotTags.map((tag) => (
                  <a
                    key={tag}
                    href="#discussion"
                    className="rounded-full border border-background-300/80 px-3 py-1.5 text-xs text-foreground-700 transition-colors hover:border-accent-400 hover:bg-accent-50 hover:text-accent-800 cursor-pointer"
                  >
                    #{tag}
                  </a>
                ))}
              </div>
            </div>
          </aside>
        </div>
      </div>
    </section>
  )
}